import React, { FC, useEffect, useState } from 'react'
import { Button, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, makeStyles, MenuItem, Select, Typography } from '@material-ui/core';
import { Done, Error } from '@material-ui/icons';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import LoadingButton from '../../components/buttons/LoadingButton';
import { useLocation } from 'react-router-dom';
import * as mobilbase from '../../api/mobilbase';
import * as infomodul from '../../api/infomodul';
import { RouteLocationProps } from '../../routes/mobilbase';
import { DeviceMangeResult } from '../../api/mobilbase/models';
import { GalleryImage } from '../../api/infomodul/models';
import APIRequest from '../../components/helpers/APIRequest';

const useStyles = makeStyles((theme) => ({
    paper: {
      marginTop: theme.spacing(3),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    grid: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(3),
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
  })); 

  type FormValues = {
    imageNumber: string;
  }
  

const DeviceManage: FC = () => {
  const classes = useStyles();
  const routeLocation = useLocation<RouteLocationProps>();
  const {selectedLocationId, selectedDeviceId, selectedDeviceName} = (routeLocation.state) ? routeLocation.state : new RouteLocationProps();
  const [images, setImages] = useState<GalleryImage[]>([]);
  const [isPending, setIsPending] = useState(false);
  const [runGetImages, setRunGetImages] = useState(true);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [runSetOutOfOrder, setRunSetOutOfOrder] = useState(false); 
  const [selectedImage, setSeletedImage] = useState(0);
  const [runRestart, setRunRestart] = useState(false); 
  const [restartType, setRestartType] = useState("restart");
  const [data, setData] = useState<DeviceMangeResult>({msg: ""});
  const [showMsg, setShowMsg] = useState(false)

  useEffect(() => {
    if (showMsg) {
      if (data.msg) {
        setMessage(data.msg)
      }
    }
  }, [showMsg, data.msg]);

  const { handleSubmit, control } = useForm<FormValues>({
    defaultValues: {
      imageNumber: "-1"
    }
  });

  const handleClick = async (name: string) => {
    if (!isPending) {
      setShowMsg(true);
      setRestartType(name);
      setRunRestart(true);
    }
  };

  const RequestRestart = () => {
    return (
      <APIRequest<DeviceMangeResult> 
          run={runRestart} 
          setRun={setRunRestart}
          pending={isPending}
          setIsPending={setIsPending} 
          req={() => mobilbase.postManageDevice({
            locationId: +selectedLocationId,
            deviceId: +selectedDeviceId,
            body: {
              name: restartType,
              imageNumber: -1
            }
          })}
          setData={setData}
      />
    );
  }

  const handleClose = () => {
    setData({msg: ""})
    setShowMsg(false);
    setMessage("");
    setError("");
  };

  const onSubmit: SubmitHandler<FormValues> = async data => {
    if (!isPending) {
      setShowMsg(true);
      setSeletedImage(+data.imageNumber);
      setRunSetOutOfOrder(true);
    }
  }

  const RequestSetOutOfOrder = () => {
    return (
      <APIRequest<DeviceMangeResult> 
          run={runSetOutOfOrder} 
          setRun={setRunSetOutOfOrder}
          pending={isPending}
          setIsPending={setIsPending} 
          req={() => mobilbase.postManageDevice({
            locationId: +selectedLocationId,
            deviceId: +selectedDeviceId,
            body: {
              name: 'I drift',
              imageNumber: selectedImage,
            }
          })}
          setData={setData}
      />
    );
  }

  const RequestOutOfOrderImages = () => {
    return (
      <APIRequest<GalleryImage[]> 
          run={runGetImages} 
          setRun={setRunGetImages}
          pending={isPending}
          setIsPending={setIsPending} 
          req={() => infomodul.getOutOfOrderImages({masterId: selectedLocationId, deviceId: selectedDeviceId})}
          setData={setImages}
      />
    );
  }

  return (
    <Container maxWidth="md">
      <RequestOutOfOrderImages />
      <RequestRestart />
      <RequestSetOutOfOrder />
        <div className={classes.paper}>
            <Typography component="h1" variant="h5">
                Administration - {((selectedDeviceName) ? selectedDeviceName : "")}
            </Typography>
        <div className={classes.grid}>
        <Grid container spacing={2}>
            <Grid item xs={12}>
            <form onSubmit={handleSubmit(onSubmit)}>
              {/* <select name="imageNumber" ref={register} defaultValue="-1" > 
                <option  value="-1"> Standart billed </option >
                {images.map((v, index) => {
                  return <option  value={"" + v.imageNumber} key={index}>{v.imgDescription}</option >
                })}
                <option value="male">male</option> fullWidth variant="outlined"
                <option value="other">other</option>
              </select> */}
              <Controller
                name="imageNumber"
                as={
                  <Select fullWidth variant="outlined">
                    <MenuItem value={"-1"}> Standard billed </MenuItem  >
                    {images.map((v, index) => {
                      return <MenuItem   value={"" + v.id} key={index}>{v.imgDescription}</MenuItem  >
                    })}
                  </Select>
                }
                control={control}
              />

            <LoadingButton pending={isPending} text={"Sæt i drift/ud af drift"} update={() => {}}/>
          </form>
                {/* <Button onClick={e => handleClick('I drift')} fullWidth variant="contained" color="primary">
                    Sæt i drift/ud af drift
                </Button> */}
            </Grid>
            <Grid item xs={12}>
                <Button onClick={e => handleClick('kørt')} fullWidth variant="contained" color="primary">
                    Genstart kort/mønt
                </Button>
            </Grid>
            <Grid item xs={12}>
                <Button onClick={e => handleClick('printer')} fullWidth variant="contained" color="primary">
                    Genstart printer
                </Button>
            </Grid>
            <Grid item xs={12}>
                <Button onClick={e => handleClick('restart')} fullWidth variant="contained" color="primary">
                    Genstart automat
                </Button>
            </Grid>
          </Grid>
        </div>
        <Dialog
          open={((isPending && showMsg) || !!message || !!error)}
          //onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Handlingen sendes"}</DialogTitle>
          <DialogContent>
            {isPending &&
                <CircularProgress />
            }
            {message &&
                <DialogContentText id="alert-dialog-description">
                    <Done />
                    {((message) ? message : "")}
                </DialogContentText>
            }
            {error &&
                <DialogContentText id="alert-dialog-description">
                    <Error />
                    {((error) ? error : "")}
                </DialogContentText>   
            }
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary" autoFocus>
              Luk
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      </Container>
  );
}

export default DeviceManage;